import { render, staticRenderFns } from "./jurisdiction_list copy.vue?vue&type=template&id=047bc986&scoped=true&"
import script from "./jurisdiction_list copy.vue?vue&type=script&lang=js&"
export * from "./jurisdiction_list copy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "047bc986",
  null
  
)

export default component.exports